export class VW_SERIES {
    constructor(
        public SERIES_ID: number,
        public AUCTION_ID: number,
        public SERIES_NAME: string,
        public COUPON: number,
        public MATURITY_DATE: Date,
        public BT_ID: string,
        public MIN_BID: string,
        public MAX_BID: string,
        public INCREMENTAL: string,
        public PRICE: number,
        public FEE: number,
        public LOGO: number,
        public THEME: number,
        public CG_PRICE: number,
        public CD_PRICE: number,
        public D_CREATED: number,
        public CREATED_BY: number,
        public UPD_BY: number,
        public CG_STATUS: number,
        public CD_STATUS: string,
        public MIN_HOLDING_PERIOD: Date,
        public SMIN_HOLDING_PERIOD: string,
        public CHECKED: boolean,
        public FIRST_COUPON_DATE: Date,
        public SFIRST_COUPON_DATE: string,
        public PAYMENT_T_LIMIT : Date,
        public SPAYMENT_T_LIMIT : string,
        public PAYMENT_GRACE : Date,
        public SPAYMENT_GRACE : string,
        public BUFFER : number
    ) { }
}

export class SERIES {
    constructor(
        public SERIES_ID: number,
        public AUCTION_ID: number,
        public SERIES_NAME: string,
        public COUPON: number,
        public MATURITY_DATE: Date,
        public SMATURITY_DATE: string,
        public BT_ID: number,
        public MIN_BID: number,
        public MAX_BID: number,
        public INCREMENTAL: number,
        public CREATED_BY: number,
        public SR_ID: number,
        public MAX_PCENT: number,
        public FIRST_COUPON: number,
        public DESCRIPTION: string,
        public TARGET: number,
        public COUPON_DATE: string,
        public LINK_MEMO: string,
        public EXPIRED_MINUTES: number,
        public CG_PRICE: number,
        public CD_PRICE: string,
        public CG_STATUS: number,
        public CD_STATUS: string,
        public MIN_HOLDING_PERIOD: Date,
        public SMIN_HOLDING_PERIOD: string,
        public UPD_BY: number,
        public NEXT_COUPON: number,
        public ACR_INT: number,
        public CONFIRM_BY: number,
        public FIRST_COUPON_DATE: Date,
        public SFIRST_COUPON_DATE: string,
        public CHECKER: string,
        public PAYMENT_T_LIMIT : Date,
        public SPAYMENT_T_LIMIT : string,
        public PAYMENT_GRACE : Date,
        public SPAYMENT_GRACE : string,
        public BUFFER : string,
        public CG_ONLINE: number,
        public CD_ONLINE: string,
        public MIN_OWNERSHIP: number
    ) { }
}

export class SERIES_REDEEM {
    constructor(
        public SR_ID: number,
        public SERIES_ID: number,
        public AUCTION_ID: number,
        public MIN_BID: number,
        public INCREMENTAL: number,
        public MAX_PCENT: number,
        public MIN_OWNERSHIP: number

    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/series.ts